import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setIsSearched, setSearchQuery } from '../../store/reducers/searchSlice';
import { setDay, setSites } from '../../store/reducers/scheduleReducer';
import classes from './SearchBar.module.scss';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { SEARCH_MAX_LENGTH } from '../../config/constants';

const SearchBar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const searchQuery = useSelector((state) => state.search.query);
    const isSearched = useSelector((state) => state.search.isSearched);
    const scheduleDay = useSelector((state) => state.schedule.day);
    const scheduleSite = useSelector((state) => state.schedule.sites);
    const [searchBarString, setSearchBarString] = useState(searchQuery ? searchQuery : '');
    const [isSearching, setIsSearching] = useState(false);
    const isMobile = useMediaQuery('(max-width:768px)');

    // The auction page can change the query too (applying a saved search, removing the
    // "Search" chip). Declared before the schedule effect so a schedule pick still wins.
    useEffect(() => {
        setSearchBarString(searchQuery || '');
    }, [searchQuery]);

    useEffect(() => {
        if(scheduleSite && scheduleSite.length > 0){
            setSearchBarString(`${scheduleSite.map((site) => site).join(' ')}`);
        }
    }, [scheduleDay, scheduleSite]);

    const handleSearchChange = (e) => {
        setSearchBarString(e.target.value);
        dispatch(setDay(''));
        dispatch(setSites([]));
    };

    const handleSearch = () => {
        setIsSearching(true);
        navigate('/auction');
        dispatch(setSearchQuery(searchBarString));
        dispatch(setIsSearched(!isSearched));
        
        // Simulate search delay for better user feedback
        setTimeout(() => {
            setIsSearching(false);
        }, 800);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const onClickFavoriteHandler = () => {
        navigate('/garage?source=auction&tab=favorites');
    };

    return (
        <div className={classes.SearchBarDiv}>
            <div className={classes.searchBarFieldDiv}>
                <input
                    className={classes.searchBarInput}
                    type="text"
                    placeholder={isMobile ? "Make, model or year" : "Search by Make, Model, or Year (e.g., Nissan Skyline, 1999)"}
                    value={searchBarString}
                    maxLength={SEARCH_MAX_LENGTH}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                />
                <button 
                    className={classes.favoritesButton} 
                    onClick={onClickFavoriteHandler}
                    aria-label="Go to favorites"
                >
                    <i className="far fa-heart"></i>
                    {!isMobile && "Favorites"}
                </button>
                <button 
                    className={classes.searchBarButton}
                    onClick={handleSearch}
                    disabled={isSearching}
                >
                    {isSearching ? (
                        <>
                            <i className="fas fa-circle-notch fa-spin"></i>
                            {!isMobile && "Searching..."}
                        </>
                    ) : (
                        <>
                            <i className="fas fa-search"></i>
                            {!isMobile && "Search"}
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default SearchBar;
